module.exports = __webpack_public_path__ + "static/media/hitomi-icon.8bbf804a.png";